import {
  PractitionerEntityType,
} from "@/lib/supabase/supabaseTypes";
import { PractitionerForm } from "@/dentlab/src/forms/form-components/practitioner/insert-update/practitioner.form";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/dentlab/src/components/ui/dialog";

export const PractitionerFormDialog: React.FC<{
  open: boolean;
  onClose: () => void;
  onSave?: (practitioner: PractitionerEntityType) => void;
  practitioner?: PractitionerEntityType;
  clientId?: string;
  jobId?: number;
}> = ({ open, onClose, practitioner, clientId, jobId, onSave }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Behandler</DialogTitle>
        </DialogHeader>
        {practitioner ? (
          <PractitionerForm
            practitioner={practitioner}
            onClose={onClose}
            onSave={onSave}
          />
        ) : (
          <PractitionerForm onClose={onClose} clientId={clientId ?? ""} jobId={jobId} onSave={onSave}  />
        )}
      </DialogContent>
    </Dialog>
  );
};
